import Loader from 'components/loaders/Loader';
import { ShouldRender } from 'components/ShouldRender';
import React, { useContext, useState } from 'react';
import { useLaundrySchedules } from 'services/laundry/schedules';
import { useSubmitResourceBooking } from 'services/laundry/submit-resource-booking';
import { isBefore } from 'date-fns';
import { LaundryBrikkModalContext } from '../../index';
import { getDateFromNow } from '../DateSelectionSection';
import { useLaundryBookings } from '../../../../../../../../services/laundry/bookings';
import { ScheduleCard } from './components/ScheduleCard';
import styles from './styles.module.scss';

function formatDate(date, options) {
  return new Date(date)
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      ...options,
    })
    .replace(',', '');
}

export function WhatAndWhenSection() {
  const { selectedDate, selectedEndDate, selectedResource } = useContext(
    LaundryBrikkModalContext,
  );
  const { laundrySchedules, isFetching: isFetchingForLaundrySchedules } = useLaundrySchedules(
    selectedResource?.id,
  );
  const [submittedSchedule, setSubmittedSchedule] = useState();
  const { submitResourceBooking, isLoading } = useSubmitResourceBooking();

  const minDate = getDateFromNow(laundrySchedules?.bookingRule?.notAfter);

  const updatedSelectedDate = isBefore(selectedDate, minDate) ? minDate : selectedDate;

  const dayOfWeek = updatedSelectedDate ? updatedSelectedDate.toLocaleDateString('en-GB', {
    weekday: 'long',
  }) : '';

  const formattedDate = formatDate(updatedSelectedDate, {
    weekday: 'short',
  });
  const formattedEndDate = formatDate(selectedEndDate);

  const { laundryBookings, isFetching: isFetchingFromLaundryBookings } = useLaundryBookings(
    selectedResource?.id,
  );

  const formattedDateByDayMonth = formatDate(updatedSelectedDate); // example: 31 Jan
  if (isFetchingForLaundrySchedules && isFetchingFromLaundryBookings) return <Loader />;

  return (
    <div className={styles.cardsSectionWrapper}>
      {laundrySchedules?.schedules?.map((schedule, index) => {

        const isBookedTimeSlot = laundryBookings?.find(laundryBooking => laundryBooking?.date === formattedDateByDayMonth
         && `${schedule?.from}-${schedule?.to}` === `${laundryBooking?.from}-${laundryBooking?.to}`);

        return (
          <ShouldRender
            key={index}
            condition={
          laundrySchedules?.available
          && dayOfWeek === schedule?.day && (laundrySchedules?.scheduleType === 'daily' ? selectedEndDate : true)
          && !isBookedTimeSlot
         }
          >
            <ScheduleCard
              date={formattedDate}
              address={selectedResource?.address}
              from={schedule?.from}
              to={schedule?.to}
              dateTo={formattedEndDate}
              showRange={laundrySchedules?.scheduleType === 'daily'}
              isLoading={submittedSchedule === index && isLoading}
              onClick={() => {
                setSubmittedSchedule(index);
                submitResourceBooking({
                  date: updatedSelectedDate,
                  endDate: selectedEndDate,
                  resourceId: selectedResource?.id,
                  from: schedule?.from,
                  to: schedule?.to,
                  scheduleType: laundrySchedules?.scheduleType,
                });
              }}
            />
          </ShouldRender>
        );
      })}
    </div>
  );
}
